import Keycloak from 'keycloak-js';
import { env } from 'shared/config';
import { KeycloakTypes } from './types';

const AUTH_TOKEN_MIN_VALIDITY = 60;

const OFFICE_CONFIG = {
  clientId: env.X5_KEY_CANDIDATE_OFFICE_CLIENT_ID,
  realm: env.X5_KEY_CANDIDATE_OFFICE_REALM,
  url: `${env.X5_KEY_UI_HOST.replace(/\/$/, '')}/auth`,
};
const MASS_CONFIG = {
  clientId: env.X5_KEY_CANDIDATE_MASS_CLIENT_ID,
  realm: env.X5_KEY_CANDIDATE_MASS_REALM,
  url: `${env.X5_KEY_UI_HOST.replace(/\/$/, '')}/auth`,
};
const CONFIGS = {
  [KeycloakTypes.office]: OFFICE_CONFIG,
  [KeycloakTypes.mass]: MASS_CONFIG,
};

export let keycloak: Keycloak | null = null;

export const initKeycloak = async (type: KeycloakTypes) => {
  const config = CONFIGS[type];
  keycloak = new Keycloak(config);

  try {
    const authenticated = await keycloak.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
      checkLoginIframe: false,
      scope: 'openid',
      //response_type: 'code',
    });
    return authenticated;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getToken = async () => {
  if (!keycloak) return;

  try {
    if (keycloak.isTokenExpired(AUTH_TOKEN_MIN_VALIDITY)) {
      await keycloak.updateToken(AUTH_TOKEN_MIN_VALIDITY);
    }
  } catch (e) {
    console.error(e);
    keycloak?.logout?.();
    return null;
  }
  return keycloak?.token ?? null;
};
